import { Controller } from '@hotwired/stimulus';

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["removeFeatured"] }] */
export default class extends Controller {
  static targets = ['row']

  connect () {
    this.highlightedFeaturedUpdate();

    const targetNode = this.element.querySelector('tbody');
    this.observer = new MutationObserver(() => { this.highlightedFeaturedUpdate(); });
    this.observer.observe(targetNode, { childList: true });
  }

  disconnect () {
    this.observer.disconnect();
  }

  removeFeatured (event) {
    event.preventDefault();
    const editForm = event.target.closest('tr').querySelector('form');
    const submit = editForm.querySelector('.js-row__submit');
    const allProgramsTable = document.querySelector('#all-programs-table');
    const { programId } = event.target.dataset;
    const featuredCheckbox = allProgramsTable.querySelector(`#feature-checkbox-${programId}`);

    if (featuredCheckbox) { featuredCheckbox.checked = false; }
    editForm.querySelector('#js-feature-value').checked = false;
    submit.click();
  }

  highlightedFeaturedUpdate () {
    Array.from(this.rowTargets).slice(0, 6).forEach((row) => {
      row.classList.add('featured-row--highlighted');
    });
    Array.from(this.rowTargets).slice(6).forEach((row) => {
      row.classList.remove('featured-row--highlighted');
    });
  }
}
